import {
  getData,
} from 'src/services/RestApi';
import { formatDate } from 'src/utils/date-locale';
import StringUtils from 'src/utils/string-util';
import { formatDecimal, formatQuantity, calculateTotalFuel, formatCode } from 'src/utils/formatters';
import { parseStringToArrayVL } from 'src/utils/string-parsers';
import { paymentColor } from 'src/utils/color-rules';

/**
 * TMS
 */
export const getTmsList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/tms/censor-list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) {
    return onError(error);
  }

  result.forEach((element) => {
    if(element.checkOut > 0)
      element.trips = formatDecimal(element.checkoutKm - element.checkinKm);
    element.checkIn = formatDate(element.checkIn, 'dd/MM/yy - HH:mm');
    element.checkOut = formatDate(element.checkOut, 'dd/MM/yy - HH:mm');
    element.checkinBy = formatDate(element.checkinBy, 'HH:mm');
    element.checkoutBy = formatDate(element.checkoutBy, 'HH:mm');
  });
  return onSuccess(result);
};

export const getTmsItem = async (payload) => {
  const tmsId = Number(payload?.id) || 0;
  if (tmsId === 0) return {};

  const { result, error } = await getData('api/tms/detail', { tmsId });
  if(error) return {};

  result.checkinSys = formatDate(result.checkIn, 'dd/MM/yy - HH:mm:ss');
  result.checkoutSys = formatDate(result.checkOut, 'dd/MM/yy - HH:mm:ss');
  result.checkinHint = result.checkinBy || result.checkIn;
  result.checkoutHint = result.checkoutBy || result.checkOut;
  result.trips = formatDecimal(result.checkoutKm - result.checkinKm);

  return result;
};

export const getTmsNew = async () => {
  const { result } = await getData('api/tms/censor-new', {});
  const length = result.length; 
  // const randomIndex = Math.floor(Math.random() * length);
  // const reducedList = result.filter((_, index) => index !== randomIndex);
  
  return { total: length, list: result };
};
// EOF

/**
 * FUEL
 */
export const getFuelList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/fuel/censor-list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);
  
  result.forEach((element) => {
    element.fuelDate = formatDate(element.fuelDate, 'dd/MM/yyyy');
    element.fuelQuantity = formatQuantity(element.fuelQuantity);
    element.cardNumber = StringUtils.getLastNChars(element.cardNumber, 4);
    element.fuelPrice = formatDecimal(element.fuelPrice);
    element.billNo = formatCode(element.billNo);
  });
  return onSuccess(result);
}

export const getFuelItem = async (payload) => {
  const fuelId = Number(payload?.id) || 0;
  if (fuelId === 0) return {};

  let { result, error } = await getData('api/fuel/detail', { fuelId });
  if(error) return {};

  const quantity = result.quantity;
  result.totalPrice = calculateTotalFuel(quantity, result.price);
  result.quantity = formatQuantity(quantity);

  result.cardNumber = StringUtils.getLastNChars(result.cardNumber, 4);
  // result.paidDate = formatDate(result.paidDate, 'dd/MM/yyyy');

  return result;
};

export const getFuelNew = async () => {
  const { result } = await getData('api/fuel/censor-new', {});
  const length = result.length; 
  // const randomIndex = Math.floor(Math.random() * length);
  // const reducedList = result.filter((_, index) => index !== randomIndex);
  
  return { total: length, list: result };
};
// EOF

/**
 * REPAIR
 */
export const getRepairList = async (
  payload, {},
  onEndPoint = () => {},
  onSuccess = () => {},
  onError = () => {},
) => {
  const endPoint = 'api/repair/censor-list';
  onEndPoint(endPoint);

  const { result, error } = await getData(endPoint, payload);
  if (error) return onError(error);

  result.forEach((element) => {
    element.repairDate = formatDate(element.atTime, 'dd/MM/yyyy');
    element.services = parseStringToArrayVL(element.services);
    if (element.atKm > 0) {
      element.atKm = element.atKm.toLocaleString();
    }
    if (element.price) {
      element.price = element.price.toLocaleString();
    }

    element.paymentColor = paymentColor(element.paymentStatus);
  });
  return onSuccess(result);
}

export const getRepairItem = async (payload) => {
  const repairId = Number(payload?.id) || 0;
  if (repairId === 0) return {};

  let { result, error } = await getData('api/repair/detail', { repairId });
  if(error) return {};

  result.services = parseStringToArrayVL(result.services);
  
  // const quantity = result.quantity;
  // result.totalPrice = calculateTotalFuel(quantity, result.price);
  // result.quantity = formatQuantity(quantity);

  // result.cardNumber = StringUtils.getLastNChars(result.cardNumber, 4);
  // result.paidDate = formatDate(result.paidDate, 'dd/MM/yyyy');

  return result;
};

export const getRepairNew = async () => {
  const { result } = await getData('api/repair/censor-new', {});
  const length = result.length; 
  // const randomIndex = Math.floor(Math.random() * length);
  // const reducedList = result.filter((_, index) => index !== randomIndex);
  
  return { total: length, list: result };
};
// EOF